
const state = {
  headerHeight:220,
  packUnfold:true,
  users:{},
  permission:{},
  mask:0,
}

const mutations = {
  SET_GRADEID: (state,id) => {
    state.headerHeight = id;
  },
  SET_PACKUNFOLD: (state,packUnfold) => {
    state.packUnfold = packUnfold;
  },
  SET_USERS:(state,user)=>{
    state.users=user
  },
  SET_PER:(state,permission)=>{
    state.permission=permission
  },
  SET_MASK:(state,mask)=>{
    state.mask=mask
  },
}

const actions = {

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}




// WEBPACK FOOTER //
// ./src/store/modules/user.js